const remBase = 16;

export const remPx = px => `${px / remBase}rem`;
